import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { User } from 'src/app/core/objects/user';
import { UserService } from 'src/app/core/services/user.service';
import { WhiteLabelService } from 'src/app/core/services/white-label.service';
import { CompanyBranding } from 'src/app/core/types';

@Component({
    selector: 'gl-base-modal',
    templateUrl: './base-modal.component.html',
    styleUrls: ['./base-modal.component.scss'],
    standalone: false
})
export class BaseModalComponent implements OnDestroy {
  @Input() public disableCloseButton = false;
  public user: User;
  public userSub: Subscription;
  public logo: CompanyBranding;
  @Output() private closeModal = new EventEmitter<any>();

  constructor(private userService: UserService, private whiteLabelService: WhiteLabelService) {
    this.userSub = this.userService.user.subscribe((user: User) => (this.user = user));
    this.logo = this.whiteLabelService.getState();
  }

  public ngOnDestroy() {
    this.userSub.unsubscribe();
  }

  public close(): void {
    this.closeModal.emit();
  }
}
